const ReactDOM = require("react-dom/client")
const LogRocket = require("logrocket")

exports.replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

exports.onInitialClientRender = () => {
  if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
    LogRocket.init("9j68ze/lasoft")
  }
}
